import React from "react";
import { SOCKET_CONNECTION } from "../hook/useSocketConnection";

const STATUS_VIEW = {
  [SOCKET_CONNECTION.CONNECTED]: { label: "Terhubung", dot: "bg-success" },
  [SOCKET_CONNECTION.RECONNECTING]: {
    label: "Menyambung ulang...",
    dot: "bg-warning",
  },
  [SOCKET_CONNECTION.DISCONNECTED]: { label: "Terputus", dot: "bg-error" },
};

// Indikator koneksi realtime konduktor ke server lelang.
const SocketStatusBadge = ({ status }) => {
  const view = STATUS_VIEW[status] ?? STATUS_VIEW[SOCKET_CONNECTION.RECONNECTING];

  return (
    <div
      className="fixed bottom-4 left-4 z-50 flex items-center gap-2 rounded-full bg-white px-3 py-1 shadow-md font-sourceSansPro"
      role="status"
      aria-live="polite"
    >
      <span className={`h-2 w-2 rounded-full ${view.dot}`} aria-hidden="true" />
      <span className="text-sm text-text-dark">{view.label}</span>
    </div>
  );
};

export default SocketStatusBadge;
